import script from "./AiCustomizationPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiCustomizationPanel.vue?vue&type=script&setup=true&lang=ts"

import "./AiCustomizationPanel.vue?vue&type=style&index=0&id=dafd85a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dafd85a4"]])

export default __exports__